/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { AboutChild, Eligibility, InputData, OrderOfBC } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { Transition2Validation } from './transition_2.validator';
import { Confirm } from 'src/refresh/service/constant';

@Component({ 
      selector: 'transition_2',
      templateUrl: './transition_2.component.html',
      styleUrls: ['./transition_2.component.less']
})
export class Transition2Component extends FormBaseComponent implements OnInit {

      eligibility : Eligibility;
      orderOfBC : OrderOfBC;
      aboutChild : AboutChild;

      constructor( protected router: Router ,
                   public timerService:TimerService,
                   public data:InputData ) {

            super(router,timerService);  

            let prevPage = !this.data.orderOfBC.chk_BCConsent? Path.BirthCertificateAreYouSure
                                                             : Path.BirthCertificate;

            if ( this.data.eligibility.isCustodyOtherThanParent == Confirm.YES ) {
                  super.setNextPage(Path.OrderSummary,prevPage);
            }      
            else  super.setNextPage(Path.CCBMain,prevPage);
                                                
            super.setValidator(new Transition2Validation(this));

            this.eligibility = this.data.eligibility;
            this.orderOfBC = this.data.orderOfBC;
            this.aboutChild = this.data.aboutChild;

            InputData.currentPageIdx = 19;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {
            
            super.forwardNext(this.data.eligibility.listedParentCount);

      }

      noException(){
            return !(this.aboutChild.isChildDeceased == 'Y' ||
                  this.eligibility.isCustodyOtherThanParent == 'Y');
      }

      childDeceased() {
            return this.aboutChild.isChildDeceased == 'Y';
      }
}
